import React from "react";
import { 
  Wrench, Thermometer, Home as HomeIcon, Zap, PaintBucket, Bath, 
  Settings, Truck, Trash2, Droplets, Square, Sun, Bug, DoorOpen,
  Wind, Plane, Container, Toilet, Lock, Flame, Fan
} from "lucide-react";

// All offers with rates from PDF
const allOffers = [
  { name: "Plumbers", payout: "Up to $98.50", icon: Wrench },
  { name: "HVAC", payout: "Up to $94.00", icon: Thermometer },
  { name: "Roofers", payout: "Up to $178.00", icon: HomeIcon },
  { name: "Electricians", payout: "Up to $57.00", icon: Zap },
  { name: "Painters", payout: "Up to $34.00", icon: PaintBucket },
  { name: "Bathroom Remodel", payout: "Up to $54.00", icon: Bath },
  { name: "Appliance Repair", payout: "Up to $36.00", icon: Settings },
  { name: "Movers", payout: "Up to $23.00", icon: Truck },
  { name: "Junk Removal", payout: "Up to $29.00", icon: Trash2 },
  { name: "Water & Fire Damage", payout: "Up to $515.00", icon: Droplets },
  { name: "Windows Installers", payout: "Up to $56.00", icon: Square },
  { name: "Solar Installation", payout: "Up to $53.00", icon: Sun },
  { name: "Heating Contractors", payout: "Up to $96.00", icon: Flame },
  { name: "Pest Control", payout: "Up to $56.00", icon: Bug },
  { name: "Garage Doors", payout: "Up to $77.00", icon: DoorOpen },
  { name: "Gutters", payout: "Up to $30.00", icon: Wind },
  { name: "Flight Booking", payout: "$20.00 Fixed", icon: Plane },
  { name: "Dumpster Rentals", payout: "$10.00 Fixed", icon: Container },
  { name: "Porta Potty", payout: "$10.00 Fixed", icon: Toilet },
  { name: "Locksmith", payout: "Up to $20.00", icon: Lock },
  { name: "Chimney Services", payout: "$15.00 Fixed", icon: Flame },
  { name: "Air Duct Cleaning", payout: "$15.00 Fixed", icon: Fan }
];

const RunningOffersBanner = () => {
  // Double the offers for seamless loop
  const doubledOffers = [...allOffers, ...allOffers];

  return (
    <div className="bg-gradient-to-r from-[#0f172a] via-[#1e3a5f] to-[#0f172a] py-4 overflow-hidden w-full max-w-[100vw]" data-testid="running-offers-banner">
      <div className="flex items-center w-full">
        <div className="flex animate-scroll-slow" style={{ width: "max-content" }}>
          {doubledOffers.map((offer, index) => (
            <div
              key={index}
              className="flex items-center gap-3 px-6 py-2 mx-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/10 whitespace-nowrap"
            >
              <offer.icon className="w-5 h-5 text-blue-400" />
              <span className="text-white font-medium">{offer.name}</span>
              <span className="text-green-400 font-bold">{offer.payout}</span>
            </div>
          ))}
        </div>
      </div>
      
      <style jsx="true">{`
        @keyframes scroll-slow {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll-slow {
          animation: scroll-slow 60s linear infinite;
        }
        .animate-scroll-slow:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default RunningOffersBanner;
